module.exports = __webpack_public_path__ + "static/media/fa-solid-900.55eb2a60.woff2";